import { styled } from "@mui/material/styles";
import React from "react";

import { MainColumnWrapper } from "../components/MainColumnWrapper";
import { TOOLBAR_HEIGHT } from "../types/HeaderBar";
import { Price as PriceType } from "../types/Price";

export type HeaderSectionProps = {
    title: string;
    showHeader?: boolean;
    withStickyAppBar: boolean;
    minPrice?: PriceType;
    ProductHeaderComponent: (props: Pick<HeaderSectionProps, "title" | "minPrice">) => React.JSX.Element;
};

const Header = styled("div")(({ theme }) => ({
    padding: theme.spacing(2, 0),
    boxShadow: "0 1px 15px rgba(0, 0, 0, 0.1)",
    position: "sticky",
    top: 0,
    zIndex: 100,
    backgroundColor: theme.palette.common.white,
    '&[data-with-sticky-appbar="true"]': {
        top: TOOLBAR_HEIGHT.sm,
        [theme.breakpoints.up("sm")]: {
            top: TOOLBAR_HEIGHT.md,
        },
    },
}));

export function ProductHeaderSection(props: HeaderSectionProps) {
    const { showHeader, title, minPrice, withStickyAppBar, ProductHeaderComponent } = props;

    if (!showHeader) return null;

    return (
        <Header data-with-sticky-appbar={withStickyAppBar}>
            <MainColumnWrapper>
                <ProductHeaderComponent title={title} minPrice={minPrice} />
            </MainColumnWrapper>
        </Header>
    );
}
